<template>
  <div>
    <div>
      <div class='row'>
        <div class='col-md-12'>
          <h3>Settings</h3>
        </div>
      </div>

      <div class="row" v-if="orgTypeSA">
        <div class="col-md-8 col-md-offset-2">
          <h4>Selfie Assessment Questions</h4>
          <div class="form-group" v-for="(q, ind) in questions" v-bind:key="ind">
            <div class="row">
              <div class="col-md-11">
                <p class="modalLabel" style="margin-left: 15px;margin-top:0px;">Question {{ q.index }}</p>
                <textarea class="modelInput form-control" style="margin-bottom:0px; font-size:125%;" v-model="q.text"
                  rows="2" maxlength="150"></textarea>
                <span class="pull-right" style="color:#6a605f; margin-right: 15px; font-size: 80%;">{{ 150 -
                  q.text.length }}</span>
              </div>
              <div class="col-md-1">
                <div class="pull-right" style="margin-top:65px;">
                  <span class="modelInput" v-on:click="deleteQuestion(ind)" style="padding:10px;">
                    <i class="glyphicon glyphicon-minus"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-offset-11 col-md-1">
              <div class="pull-right" style="margin-top:15px;">
                <span class="modelInput" v-on:click="addQuestion()" style="padding:10px;">
                  <i class="glyphicon glyphicon-plus"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-offset-2 col-md-8" style="margin-bottom:25px;">
              <span class="btn-submit-message" v-on:click="saveQuestions()" style="margin-left: 40px;">SAVE</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <h4>Selfie Assessment Invitations</h4>
          <EmailStudent v-bind:student_firstName="student_firstName" v-bind:student_lastName="student_lastName"
            v-bind:student_email="student_email" v-bind:setup="emailStudentSetup"></EmailStudent>
        </div>
      </div>

      <div class='row'>
        <div class="col-md-12">
          <h4>Slate</h4>
          <div><a href="/integration-docs" target="_blank" rel="opener">Click here for documentation</a> about the data
            fields that can be retrieved through the Slate integration.</div>
          <div class="well">{{ settingsSlateURL }}</div>
        </div>
      </div>
      <div class='row'>
        <div class="col-sm-12">
          <h4>Change Password</h4>
        </div>
        <div class="col-xs-4">
          <a :href="env.serverAddr + '/password/change/'" target="_blank">Click here to change your password.</a>
        </div>
      </div>
      <div class='row'>
        <div class="col-md-12">
          <h4>Cycle</h4>
        </div>
        <div class="col-md-6">
          <form class="form-horizontal">
            <div class="form-group col-md-12">
              <!-- this col pulls the margin in so it's not misaligned with the other Settings -->
              <label>Choose which cycle to filter on. Contact us if you would like to customize the date range of each
                cycle.</label>
              <select data-cy="cycle" class="form-control" v-bind:value="value" v-on:change="startTimer($event)">
                <option v-bind:value="cycle.cycle_id" v-bind:data-cy="'cycle-' + cycle.cycle_id"
                  v-for="cycle in org_cycles" v-bind:key="cycle.cycle_id">
                  <!-- <span v-show="cycle.cycle_id == active_cycle.cycle_id">(current {{cycle.cycle_id}} {{active_cycle.cycle_id}}) </span> -->
                  {{ cycle.label }} ({{ dateFormat(cycle.start_date) }} to {{ dateFormat(cycle.end_date) }})
                </option>
              </select>
            </div>
          </form>
        </div>
      </div>
      <div class='row'>
        <div class="col-sm-12">
          <h4>Video Playback for Glimpses (organization-wide setting)</h4>
        </div>
        <div class="col-sm-12">
          <h5>
            Would you like to block the video from Glimpse records for your organization and provide audio-only
            access for all users?
          </h5>
        </div>
        <div class="col-xs-12">
          <label>
            <input data-cy="playback-false" type="radio" name="playbackRadios" id="playbackRadios1" value="false"
              v-model="settingsPlayback.block_video">
            Play both video and audio (applies to all users in your org)
          </label>
        </div>
        <div class="col-xs-12">
          <label>
            <input data-cy="playback-true" type="radio" name="playbackRadios" id="playbackRadios1" value="true"
              v-model="settingsPlayback.block_video">
            Block video and play audio only (applies to all users in your org)
          </label>
        </div>
      </div>
      <div class='row'>
        <div class="col-xs-6">
          <br />
          <h4>Email Notices About Interviews (applies to only you)</h4>
          <div class="radio">
            <label>
              <input data-cy="interviewAlert-now" type="radio" name="optionsRadios" id="optionsRadios1" value="Now"
                v-model="settingsEmailInterview">
              Immediately <small>(each time your school receives a new interview)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="interviewAlert-daily" type="radio" name="optionsRadios" id="optionsRadios2" value="Daily"
                v-model="settingsEmailInterview">
              Daily <small>(receive a daily email on days when your school receives an interview)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="interviewAlert-weekly" type="radio" name="optionsRadios" id="optionsRadios3"
                value="Weekly" v-model="settingsEmailInterview">
              Weekly <small>(receive a weekly email for weeks when your school receives an interview) (recommended in
                most cases)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="interviewAlert-never" type="radio" name="optionsRadios" id="optionsRadios4" value="Never"
                v-model="settingsEmailInterview">
              Never
            </label>
          </div>

          <br />
          <h4>Email Notices About Ratings of Interviews (applies to only you)</h4>

          <div class="radio">
            <label>
              <input data-cy="reviewAlert-mine" type="radio" name="ratingEmailRadios" id="ratingEmailRadios1"
                value="Mine" v-model="settingsEmailReview">
              My Ratings <small>(receive an email each time you rate an interview)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="reviewAlert-all" type="radio" name="ratingEmailRadios" id="ratingEmailRadios2" value="All"
                v-model="settingsEmailReview">
              All Ratings <small>(receive an email each time anyone in your organization rates an interview)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="reviewAlert-never" type="radio" name="ratingEmailRadios" id="ratingEmailRadios3"
                value="Never" v-model="settingsEmailReview">
              Never
            </label>
          </div>

        </div>
      </div>
      <div class='row'>
        <div class="col-xs-6">
          <br />
          <h4>Email Notices About Glimpse Videos (applies to only you)</h4>
          <div class="radio">
            <label>
              <input data-cy="glimpseAlert-now" type="radio" name="glimpseEmailRadios" id="glimpseEmailRadios1"
                value="Now" v-model="settingsEmailGlimpse">
              Immediately <small>(each time your school receives a new Glimpse video)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="glimpseAlert-daily" type="radio" name="glimpseEmailRadios" id="glimpseEmailRadios2" 
                value="Daily" v-model="settingsEmailGlimpse">
              Daily <small>(receive a daily email on days when your school receives a Glimpse video)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="glimpseAlert-weekly" type="radio" name="glimpseEmailRadios" id="glimpseEmailRadios3"
                value="Weekly" v-model="settingsEmailGlimpse">
              Weekly <small>(receive a weekly email for weeks when your school receives a Glimpse video) (recommended in most cases)</small>
            </label>
          </div>
          <div class="radio">
            <label>
              <input data-cy="glimpseAlert-never" type="radio" name="glimpseEmailRadios" id="glimpseEmailRadios4"
                value="Never" v-model="settingsEmailGlimpse">
              Never
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <!-- <div class='col-xs-offset-2'> -->
          <div class="center">
            <button data-cy="settingsSubmit" type="submit" class="btn btn-primary"
              v-on:click.prevent="post_user_settings()">Save Settings</button>
          </div>
          <!-- </div> -->
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import {
  ivSpinnerMixin,
  ivAlertMixin,
} from "@/mixins/base-components-pack.js";
import moment from 'moment-timezone';
import EmailStudent from "@/components/EmailStudent.vue";
import ivbus from "@/utils/ivbus.js";

import apiClient from "../utils/apiClient.js";

import env from "../utils/env.js";

export default {
  props: [
    'ameliaaddr',
    'settingsSlateURL',
    "org_cycles",
    "orgTypes",
    "value", // filter_cycle
  ],

  // ivAlertMixin supplies showMessage(), called from the save handlers below.
  mixins: [ivSpinnerMixin, ivAlertMixin],

  components: {
    EmailStudent
  },

  data() {
    return {
      // settings page

      env: env,

      settingsEmailSubscriptionDict: {
        "interview": {
          "Now": {
            "period": null,
            "alert_object": "interview.Send",
            "alert_every": true,
            "alert_every_org": false
          },
          "Daily": {
            "period": "1",
            "alert_object": "interview.Send",
            "alert_every": false,
            "alert_every_org": false
          },
          "Weekly": {
            "period": "7",
            "alert_object": "interview.Send",
            "alert_every": false,
            "alert_every_org": false
          },
          "Never": null
        },
        "review": {
          "Mine": {
            "period": null,
            "alert_object": "organization.Review",
            "alert_every": true,
            "alert_every_org": false
          },
          "All": {
            "period": null,
            "alert_object": "organization.Review",
            "alert_every": true,
            "alert_every_org": true
          },
          "Never": null
        },
        "glimpse": {
          "Now": {
            "period": null,
            "alert_object": "glimpse.Send",
            "alert_every": true,
            "alert_every_org": false
          },
          "Daily": {
            "period": "1",
            "alert_object": "glimpse.Send",
            "alert_every": false,
            "alert_every_org": false
          },
          "Weekly": {
            "period": "7",
            "alert_object": "glimpse.Send",
            "alert_every": false,
            "alert_every_org": false
          },
          "Never": null
        }
      },

      settingsPlayback: {
        block_video: false
      },

      settingsEmailInterview: "Never",
      settingsEmailReview: "Never",
      settingsEmailGlimpse: "Never",

      // Subscriptions whose frequency this page has no radio button for — set by
      // staff in Mercury or by hand in the shell. Saving rewrites the whole set, so
      // these are carried through untouched rather than being silently deleted.
      unmanagedSubscriptions: [],


      questions: [
        { index: 1, text: "" },
        { index: 2, text: "" },
        { index: 3, text: "" },
        { index: 4, text: "" }
      ],

      student_firstName: "",
      student_lastName: "",
      student_email: "",

      emailStudentSetupLoaded: false,
      emailStudentSetup: {},

      user: {},

    }
  },

  mounted() {
    var that = this;
    that.get_user_settings(); // does this need to wait for user_org_info?

    that.fetchQuestions();
    ivbus.getFlag("user").then(function (user) {
      that.$set(that, "user", user);
      that.$set(that, "emailStudentSetup", {
        context: "selfieAssessmentInvite",
        counselor_first_name: user.first_name,
        counselor_last_name: user.last_name,
        counselor_email: user.email,
        modalLabel: "send invites",
        sendToLabel:
          "send a Selfie Assessment invite to the following email address(es):",
        sendNumber: "multiple",
        subjectLabel: "subject:",
        messageLabel: "message:",
        modalLabelStyle: "plumText",
        inviteRotateStyle: "plumText",
        inviteRotatePlacement: "top: 0px !important",
        modalInputStyle: "plumBorder",
        btnStyle: "plumButton"
      });
      that.emailStudentSetupLoaded = true;
    });
  },

  computed: {
    orgTypeSA: function () {
      return this.orgTypes.filter(function (ot) { return ot.type == "org_facing_cadenza" }).length > 0;
    },
  },

  methods: {

    // A subscription period arrives as a Django duration string ("7 00:00:00"), or
    // null for immediate. Parse the leading day count rather than reading one
    // character: a period this page can't name used to fall through to "Never", and
    // because "Never" is submitted by omission, the next save silently deleted it.
    frequencyFromPeriod: function (period) {
      if (period === null || period === undefined) {
        return 'Now';
      }
      var days = parseInt(period, 10);
      if (days === 1) {
        return 'Daily';
      }
      if (days === 7) {
        return 'Weekly';
      }
      // Anything else was set outside this page — the caller stashes it in
      // unmanagedSubscriptions and re-submits it unchanged.
      return null;
    },

    dateFormat: function (date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },

    startTimer: function ($event) {
      this.$emit('input', $event.target.value);
      this.$emit('startTimer');
    },

    get_user_settings: function () {
      var that = this;
      var spinId = this.spinStart();
      apiClient.get('/api/user/user_settings/get/').then(function (response) {
        that.spinStop(spinId);
        if (response.data.status == 200) {
          var i = 0;
          var subs = response.data.user_settings.user_subscriptions;
          that.unmanagedSubscriptions = [];
          for (i = 0; i < subs.length; i++) {
            var s = subs[i];
            if (s.alert_object == "organization.Review") {
              if (s.alert_every_org == true) {
                that.$set(that, 'settingsEmailReview', 'All');
              } else if (s.alert_every == true) {
                that.$set(that, 'settingsEmailReview', 'Mine');
              } 
            }
            if (s.alert_object == "interview.Send" || s.alert_object == "glimpse.Send") {
              var frequency = that.frequencyFromPeriod(s.period);
              if (frequency === null) {
                that.unmanagedSubscriptions.push(s);
              } else if (s.alert_object == "interview.Send") {
                that.$set(that, 'settingsEmailInterview', frequency);
              } else {
                that.$set(that, 'settingsEmailGlimpse', frequency);
              }
            }

          }

          that.$set(that, "settingsPlayback", response.data.user_settings.video_playback);

        }
      }).catch(function (error) {
        that.spinStop(spinId);
      });

    },

    post_user_settings: function () {
      var that = this;
      var settings_info = {
        "user_settings": {
          "user_subscriptions": [],
          video_playback: this.settingsPlayback
        }
      };
      //add item to settings info by looking it up in dict for each radio group
      //interview
      var interviewSE = this.settingsEmailSubscriptionDict.interview[this.settingsEmailInterview];
      if (interviewSE != null) {
        settings_info.user_settings.user_subscriptions.push(interviewSE);
      }
      //review
      var reviewSE = this.settingsEmailSubscriptionDict.review[this.settingsEmailReview];
      if (reviewSE != null) {
        settings_info.user_settings.user_subscriptions.push(reviewSE);
      }
      //glimpse
      var glimpseSE = this.settingsEmailSubscriptionDict.glimpse[this.settingsEmailGlimpse];
      if (glimpseSE != null) {
        settings_info.user_settings.user_subscriptions.push(glimpseSE);
      }

      // Carry through any subscription whose frequency has no radio here, unless the
      // AO picked a frequency for that alert type, in which case their choice wins.
      var chosen = settings_info.user_settings.user_subscriptions.map(function (s) {
        return s.alert_object;
      });
      this.unmanagedSubscriptions.forEach(function (s) {
        if (chosen.indexOf(s.alert_object) === -1) {
          settings_info.user_settings.user_subscriptions.push({
            period: s.period === null ? null : String(parseInt(s.period, 10)),
            alert_object: s.alert_object,
            alert_every: s.alert_every,
            alert_every_org: s.alert_every_org
          });
        }
      });


      var spinId = this.spinStart();
      apiClient.post('/api/user/user_settings/submit/', settings_info).then(function (request) {
        that.spinStop(spinId);
        if (request.status == 200) {
          that.showMessage('Settings Saved!', 'alert-success', that.uiMessageWaitLong);
        } else {
          that.showMessage('Settings Failed', "alert-danger", that.uiMessageWaitLong);
        }
      }).catch(function () {
        that.spinStop(spinId);
      });

    },

    // Selfie assessment questions

    addQuestion: function () {
      var that = this;
      var index = that.questions.length + 1;
      that.questions.push({ index: index, text: "" });
    },

    deleteQuestion: function (index) {
      var that = this;
      that.questions.splice(index, 1);
      that.questions.forEach(function (q, ind) {
        q.index = ind + 1;
      });
      if (that.questions.length < 4) {
        for (var i = that.questions.length; i < 4; i++) {
          that.questions.push({ index: i + 1, text: "" });
        }
      }
    },

    fetchQuestions: function () {
      var that = this;
      var spinId = this.spinStart();
      apiClient
        .get("/api/user/amelia_sa_questions/")
        .then(function (response) {
          that.spinStop(spinId);
          that.$set(that, "questions", response.data.data);
          if (that.questions.length < 4) {
            for (var i = that.questions.length; i < 4; i++) {

            }
          }
        })
        .catch(function (error) {
          that.spinStop(spinId);
          console.log(error);
        });
    },

    numberQuestions: function () {
      var that = this;
      var numberquestions = 0;
      that.questions.forEach(function (q) {
        if (q["text"].length > 0) {
          numberquestions += 1;
        }
      });
      return numberquestions;
    },

    saveQuestions: function () {
      var that = this;
      that.questions.forEach(function (q, ind) {
        if (q.text == "") {
          that.questions.splice(ind, 1);
        }
      });
      that.questions.forEach(function (q, ind) {
        q.index = ind + 1;
      });
      apiClient
        .post("/api/user/save_amelia_sa_questions/", {
          counselor_questions: that.questions
        })
        .then(function (request) {
          if (request.data.status == 200) {
            that.showMessage("Questions saved!", "alert-success", 5000);
            if (that.questions.length < 4) {
              for (var i = that.questions.length; i < 4; i++) {
                that.questions.push({ index: i + 1, text: "" });
              }
            }
          } else {
            that.showMessage(
              "Error saving questions - please try again",
              "alert-danger",
              10000
            );
          }
        });
    },


  }

}

</script>

<style lang="scss">
.modelInput {
  border: solid 2px #6a605f;
  border-radius: 15px;
  margin-bottom: 25px;
  padding: 15px;
}

.btn-submit-message {
  color: white;
  background-color: #6a605f;
  padding: 10px 40px;
  border-radius: 14px;
  font-size: 124%;
  font-weight: lighter;
}
</style>